import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Alert,
  Paper,
  Chip,
  Stack
} from '@mui/material'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Container from "@mui/material/Container";
import Emitter from '@utils/eventEmitter'

const StyledDialogContent = styled(DialogContent)({
  backgroundColor: '#fdfdfd',
  borderTop: '1px solid #eee',
  borderBottom: '1px solid #eee',
  padding: 0
})
const Input = styled('input')({
  display: 'none',
})
const InputBox = styled(Stack)({
  border: '1px solid #ccc',
  minHeight: 34,
  cursor: 'pointer',
  borderRadius: 3,
  '&:hover': {
    borderColor: '#000'
  }
})
const InputBoxCover = styled('div')({
  width: '100%',
  wordBreak: 'break-all',
  alignSelf: 'center'
})
const InputChip = styled(Chip)({
  margin: '5px 0'
})

const BulkModal = ({
  memberList,
  open,
  completeModal
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [ tempFile, setTempFile] = useState(null)

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      return
    }
    completeModal(false)
    setTempFile(null)
  }

  const handleUpdate = () => {
    if (tempFile && memberList.length > 0) {
      const memberForm = new FormData()
      memberForm.append('memberList', memberList.map(member => member.companyMemberCode))
      memberForm.append('corporateRegistration', tempFile)

      completeModal(true, memberForm)
      setTempFile(null)
    } else {
      Emitter.emit('SHOW_MESSAGE', {
        text: '첨부파일을 선택해주세요.',
        color: 'warning'
      })
    }
  }

  const handleChangeFile = (e) => {
    let files = e.target ? e.target.files : e
    if (files.length) {
      setTempFile(files[0])
    }
  }

  const handleFileDelete = (e) => {
    setTempFile(null)
    e.stopPropagation()
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      aria-labelledby="임원 정보 일괄등록"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle id="responsive-dialog-title">
        법인등기사항전부증명서 일괄 등록
      </DialogTitle>

      <StyledDialogContent>
        <Alert severity="warning" icon={false} sx={{pl: 3, mb: 1}}>
          <Typography variant="subtitle2" gutterBottom component="p">
            - 변경등기가 함께 완료된 임원인 경우에만 일괄 등록해주시기 바랍니다.
          </Typography>
          <Typography variant="subtitle2" gutterBottom component="p">
            - 이미 법인등기등본이 등록되어 있는 경우, 변경된 법인등기부등본으로 재등록할 필요가 없습니다.
          </Typography>
          <Typography variant="subtitle2" gutterBottom component="p">
            - 주민등록 번호를 포함해서 발급하며 해외 법인의 경우 해외 등기 서류로 대체해주시기 바랍니다.
          </Typography>
        </Alert>
        <Paper elevation={0} sx={{p: 3}}>
          <Typography variant="subtitle2" gutterBottom component="p">
            * 법인등기사항전부증명서를 일괄등록하실 임원의 정보를 확인해주세요.
          </Typography>
          <Paper elevation={1} variant="outlined" sx={{p: 1}}>
            <Stack direction="row" spacing={1}>
              {
                memberList && memberList.map(member => {
                  return (
                    <Chip label={member.name} variant="outlined" key={member.companyMemberCode} />
                  )
                })
              }
            </Stack>
          </Paper>
        </Paper>

        <Container sx={{mb: 2}}>
          <label htmlFor="contained-button-file">
            <Input accept="application/pdf" id="contained-button-file" type="file" onChange={handleChangeFile} />
            <InputBox direction="row" spacing={1}>
              <Button variant="contained" component="span">
                법인등기부등본 파일 첨부
              </Button>
              <InputBoxCover>
                {
                  tempFile &&
                  <InputChip
                    label={tempFile.name}
                    onDelete={(e) => handleFileDelete(e)}
                  />
                }
              </InputBoxCover>
            </InputBox>
          </label>
        </Container>
      </StyledDialogContent>

      <DialogActions>
        <Button variant="contained" onClick={handleUpdate}>
          등록
        </Button>
        <Button onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BulkModal